export class LandingSEA {

  public static element: HTMLElement;
  public static $element: JQuery<HTMLElement>;

  public static init() {

    LandingSEA.$element = $('#landing-contact-cta');
    LandingSEA.element = LandingSEA.$element.get(0);

    LandingSEA.events();
  }


  public static events() {

    LandingSEA.$element.on('click', function () {
      $('html, body').animate({
        scrollTop: $(".Landing-page-contact").offset().top
      }, 500);
      return false;
    });

  }


}